import { useToast } from '../../hooks/useToast';
import {
  TRIAL_COMPANY_RESTRICTION_TITLE,
  TrialCompanyRestrictionMessage,
} from './TrialCompanyRestrictionMessage';

const TOAST_ID = 'trial-company-restricted-toast';

/**
 * Tells a trial user that companies outside their plan were removed from an
 * AI-applied filter set, rather than letting the swap happen silently.
 */
export const useTrialCompanyRestrictionToast = () => {
  const toast = useToast();

  return (blockedNames: string[]) => {
    if (blockedNames.length === 0 || toast.isActive(TOAST_ID)) return;

    toast({
      id: TOAST_ID,
      title: TRIAL_COMPANY_RESTRICTION_TITLE,
      description: (
        <TrialCompanyRestrictionMessage
          blockedNames={blockedNames}
          toastIdClose={TOAST_ID}
        />
      ),
      status: 'warning',
      variant: 'subtle',
      position: 'top-right',
      duration: null,
      isClosable: true,
    });
  };
};
